import { fuseAdoptionConstants } from "../_redux-constants";

export function fuseAdoptionReducer(
  state = {
    // Fuse Details
    fuseAdoptionLoading: false,
    fuseAdoptionData: null,
    fuseAdoptionError: null,
  },
  action
) {
  // Fuse Details
  switch (action.type) {
    case fuseAdoptionConstants.FUSE_ADOPTION_LOADING:
      return Object.assign({}, state, {
        fuseAdoptionLoading: true,
        fuseAdoptionData: null,
        fuseAdoptionError: null,
      });
    case fuseAdoptionConstants.FUSE_ADOPTION_SUCCESS:
      return Object.assign({}, state, {
        fuseAdoptionLoading: false,
        fuseAdoptionData: action.data,
      });
    case fuseAdoptionConstants.FUSE_ADOPTION_FAILURE:
      return Object.assign({}, state, {
        fuseAdoptionLoading: false,
        fuseAdoptionData: null,
        fuseAdoptionError: action.error,
      });

    default:
      return state;
  }
}
